import React from "react";
import "../style.scss";
import StepIndicator from "./shared/StepIndicator";
import CalendarDayPicker from "../DayPicker";
import { Exercise } from "../../../models/Exercise";
import CalendarOneExercise from "./CalendarOneExercise";
import CalendarMultiExercise from "./CalendarMultiExercise";
import { SelectionState } from "./hooks/useCalendarModal";
import { useTranslation } from "react-i18next";

interface CalendarDesktopViewProps {
  selectedDate: Date;
  exerciseName: string;
  listaDat?: Date[];
  firstAvailableDate?: Date;
  soldOutDates?: Date[];
  exercise: Exercise[];
  alerts: string;
  selectionState: SelectionState;
  onDateSelect: (date: Date, name: string) => void;
  onTimeSelect?: () => void;
  joinToExerciseByPass: (exerciseIds: string, assignType: boolean, passId: number) => void;
  refreshCapacityAfterAddTicket: () => void;
  showHoursToChoose: boolean;
}

const CalendarDesktopView: React.FC<CalendarDesktopViewProps> = ({
  selectedDate,
  exerciseName,
  listaDat = [],
  firstAvailableDate,
  soldOutDates = [],
  exercise,
  alerts,
  selectionState,
  onDateSelect,
  onTimeSelect,
  joinToExerciseByPass,
  refreshCapacityAfterAddTicket,
  showHoursToChoose,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="calendar-modal-steps flex-between">
        <StepIndicator number={1} label={t("wybierz_date")} />

        {exercise.length > 0 && (
          <>
            {showHoursToChoose ? (
              <>
                <StepIndicator number={2} label={t("godzina_wejscia")} />
                <StepIndicator number={3} label={t("wybierz_rodzaj_i_ilosc_biletow")} />
              </>
            ) : (
              <StepIndicator number={2} label={t("wybierz_rodzaj_i_ilosc_biletow")} className="big-step" />
            )}
          </>
        )}
      </div>

      <div className="calendar-modal flex-between">
        <div className="box day-picker border shadow">
          <CalendarDayPicker
            getExercisesByDate={onDateSelect}
            selectedDate={selectedDate}
            exerciseName={exerciseName}
            listaDat={listaDat}
            firstAvailableDate={firstAvailableDate}
            soldOutDates={soldOutDates}
          />
        </div>

        {exercise.length > 0 && (
          <>
            {showHoursToChoose === false ? (
              <CalendarOneExercise
                alertCalendar={alerts}
                joinToExerciseByPass={joinToExerciseByPass}
                exercise={exercise[0]}
                refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
              />
            ) : (
              <CalendarMultiExercise
                alertCalendar={alerts}
                joinToExerciseByPass={joinToExerciseByPass}
                exercise={exercise}
                clicked={selectionState}
                refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
                onTimeSelect={onTimeSelect}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default CalendarDesktopView;
